import { useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { Input } from '../../shared/ui/Input/Input';
import { toast, ToastContainer } from 'react-toastify';
import { LanguageOptions } from '../../entities/LanguageOptions/index.js';
import { Select } from '../../shared/ui/Select/ui/Select.jsx';
import { UploadIcon } from '../UploadIcon';

export const CurrencyForm = ({ initialData, isEdit = false }) => {
  const [form, setForm] = useState(
    initialData || {
      title: '',
      symbol: '',
      code: '',
      mainLanguadeId: 1,
      isHidden: false,
    },
  );
  const [icon, setIcon] = useState(initialData?.iconPath || null);

  const handleSubmit = () => {
    const formData = new FormData();
    if (icon && typeof icon !== 'string') {
      formData.append('mainImg', icon);
    }
    formData.append('model', JSON.stringify(form));

    const apiMethod = isEdit
      ? apiRequests.currencies.update(formData)
      : apiRequests.currencies.create(formData);

    const query = apiMethod.then(() => {
      if (!isEdit) {
        setForm((prev) => {
          Object.keys(prev).forEach((i) => (prev[i] = ''));
          return prev;
        });
        setIcon(null);
      }
    });

    toast.promise(query, {
      pending: 'Запрос к серверу',
      error: 'Произошла ошибка',
      success: isEdit ? 'Валюта успешно обновлена' : 'Валюта успешно создана',
    });
  };

  return (
    <div>
      <div className="page-content mb-3">
        <div className="mb-3">
          <Input
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
            value={form.title}
            label={'Название валюты'}
            placeholder={'Например: Dollars'}
          />
        </div>

        <div className="mb-3">
          <Input
            onChange={(e) => setForm((prev) => ({ ...prev, symbol: e.target.value }))}
            value={form.symbol}
            label={'Символ'}
            placeholder={'Например: $'}
          />
        </div>

        <div className="mb-3">
          <Input
            onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
            value={form.code}
            label={'Код'}
            placeholder={'Например: KZ'}
          />
        </div>

        <div className="mb-3">
          <UploadIcon onSelect={setIcon} initialIcon={icon} entityType="currency" />
        </div>

        <LanguageOptions
          label={'Основной язык'}
          onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
        />

        <Select
          initialValue={form.isHidden}
          options={[
            { label: 'Да', value: true },
            { label: 'Нет', value: false },
          ]}
          onChange={(e) => setForm((prev) => ({ ...prev, isHidden: e.target.value }))}
          label={'Скрыта'}
        />
      </div>

      <div className="button-content button-right">
        <button onClick={handleSubmit} className="at-btn at-btn-medium">
          Создать
        </button>
      </div>
      <ToastContainer />
    </div>
  );
};
